// extracted by mini-css-extract-plugin
module.exports = {"link":"FarmList_link__1wHkQ","chevron":"FarmList_chevron__15_sm","check":"FarmList_check__2k7O6","checked":"FarmList_checked__2bbmM","load":"FarmList_load__3mOOL"};